import { render, staticRenderFns } from "./SearchNoResults.vue?vue&type=template&id=5837f8ec&scoped=true&"
import script from "./SearchNoResults.vue?vue&type=script&lang=js&"
export * from "./SearchNoResults.vue?vue&type=script&lang=js&"
import style0 from "./SearchNoResults.vue?vue&type=style&index=0&id=5837f8ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5837f8ec",
  null
  
)

export default component.exports